/* eslint-disable no-template-curly-in-string -- los snippets muestran código TS literal */
/* Datos del caso de estudio IAClinical. Los snippets son ilustrativos: el código del cliente es privado. */

export const SIGNED = "// uploads.service.ts — fragmento ilustrativo\nasync createUploadUrl(dto: CreateUploadDto) {\n  const key = `${dto.folder}/${randomUUID()}`;\n  const [url] = await this.storage\n    .bucket(this.bucketFor(dto.kind))\n    .file(key)\n    .getSignedUrl({\n      version: 'v4',\n      action: 'write',\n      expires: Date.now() + 5 * 60 * 1000,\n      contentType: dto.mimeType,\n    });\n  return { url, key };\n}\n\n// después: el backend solo guarda el registro\nasync registerFile(dto: RegisterFileDto) {\n  return this.files.save({ key: dto.key, name: dto.name, size: dto.size });\n}";

export const VALIDATION = "// main.ts\napp.useGlobalPipes(\n  new ValidationPipe({\n    whitelist: true,\n    forbidNonWhitelisted: true,\n    transform: true,\n  }),\n);";

export const WHATSAPP = "// notifications.service.ts — fragmento ilustrativo\nasync notifySpecialist(audit: Audit) {\n  await this.twilio.messages.create({\n    from: 'whatsapp:' + this.sender,\n    to: 'whatsapp:' + audit.specialist.phone,\n    body: `Tienes un nuevo caso asignado: ${audit.code}`,\n  });\n}";

export const GCP = [
  {
    "icon": "server",
    "name": "Cloud Run",
    "text": "Servicios en contenedores"
  },
  {
    "icon": "database",
    "name": "Cloud SQL",
    "text": "PostgreSQL administrado"
  },
  {
    "icon": "cloud",
    "name": "Cloud Storage",
    "text": "Archivos y URLs firmadas"
  },
  {
    "icon": "clock",
    "name": "Cloud Scheduler",
    "text": "Tareas programadas"
  },
  {
    "icon": "layers",
    "name": "Docker",
    "text": "Imágenes de cada servicio"
  }
];

// Lo que se muestra de IAClinical en la home: no hay capturas públicas ni acceso al código.
export const IAC_SERVICES = [
  { icon: "server", name: "NestJS", text: "2 microservicios propios" },
  ...GCP.filter((g) => g.name !== "Docker"),
  { icon: "chat", name: "Twilio", text: "Mensajería por WhatsApp" },
];
